import { sendGoogleEvent } from '@html/_common/utils';

export default function SerpToursBrochure(
  SELECTOR_JS_BROCHURE_BUTTON,
  SELECTOR_JS_TOUR_CARD,
  SELECTOR_JS_TOUR_NAME,
) {
  let isDownloadBrochureInitialised = false;
  let $obj;
  let tourId;
  this.loadAndShowBrochurePopup = ($element) => {
    import(/* webpackChunkName: "brochure" */'@html/_common/brochure').then((module) => {
      const Brochure = module.default;
      const brochure = new Brochure();

      /* prepare parameters */
      $obj = $element.closest(SELECTOR_JS_TOUR_CARD);
      tourId = $obj.attr('data-id');
      const tourName = $obj.find(SELECTOR_JS_TOUR_NAME).text().trim();
      const tourPrice = $obj.attr('data-price');
      const tourNetRevenueV2 = $obj.attr('data-net-revenue');
      const tourCredits = 0;
      const tourPositionOnSERP = this.trackingTourPosition();

      const tourOperator = $obj
        .find('.values')
        .find('dd:last-child')
        .find('a:first-child')
        .text();

      /* load and show popup */
      if (!isDownloadBrochureInitialised) {
        isDownloadBrochureInitialised = true;

        brochure.load(() => {
          brochure.initiatePopup(tourPositionOnSERP);
          brochure.fillForm(
            tourId,
            tourName,
            tourOperator,
            tourNetRevenueV2,
            tourCredits,
            tourPrice,
            'Open Thank you - SERP Page',
          );
        });
      } else {
        brochure.fillForm(
          tourId,
          tourName,
          tourOperator,
          tourNetRevenueV2,
          tourCredits,
          tourPrice,
          'Open Thank you - SERP Page',
        );
      }

      sendGoogleEvent(
        'Download Brochure',
        'Open Enter Email - SERP Page',
        tourName,
        {
          dimension10: tourId,
          tourPrice,
          tourID: tourId,
          ampEventName: 'brochure_download_form_opened',
          tourName,
          tourOperator,
          tourPositionOnSERP,
        },
      );
    });
  };

  this.renderBrochure = (event) => {
    event.preventDefault();
    const $element = $(event.currentTarget);
    this.loadAndShowBrochurePopup($element);
  };

  this.initiate = () => {
    /* tour button click */
    $('.list').on('click', SELECTOR_JS_BROCHURE_BUTTON, (e) => this.renderBrochure(e));
  };

  this.trackingTourPosition = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const pageStr = urlParams.get('page');
    const page = pageStr ? parseInt(pageStr, 10) : 1;
    const NUMBER_OF_TOURS_PER_PAGE = parseInt($('main').attr('data-onpage'), 10);
    let position = null;

    if ($obj.length > 0) {
      $(SELECTOR_JS_TOUR_CARD).each((index, block) => {
        if ($(block).data('id') === Number(tourId)) {
          position = (page - 1) * NUMBER_OF_TOURS_PER_PAGE + (index + 1);
        }
      });
    }

    return position;
  };
}
